module.exports = __webpack_public_path__ + "static/img/kefu_code.2a771a20.jpeg";